import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const isTrialOutflowMobile = isFeature('trial-outflow-mobile-enable');
